module.exports = __webpack_public_path__ + "static/media/coins-default.b34b0cac.png";